import { makeStyles } from 'tss-react/mui';
import {
  BORDER_BUTTON_GREY,
  SECONDARY_BLUE_2,
  SECONDARY_BLUE_2_TRANSPARENT_40,
  SECONDARY_BLUE_BACKGROUND,
  TEXT_BUTTON_GREY,
  WHITE,
} from 'utilities/colors';

export const useButtonStyles = makeStyles()(() => ({
  'blue-outlined': {
    padding: '0.5rem 1rem',
    color: TEXT_BUTTON_GREY,
    border: `1px solid ${BORDER_BUTTON_GREY}`,

    '&:hover': {
      color: SECONDARY_BLUE_2,
      background: SECONDARY_BLUE_BACKGROUND,
      border: `1px solid ${SECONDARY_BLUE_2}`,
    },
  },
  'blue-contained': {
    padding: '0.5rem 1rem',
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    marginLeft: '1rem',
    color: SECONDARY_BLUE_2,
    background: SECONDARY_BLUE_BACKGROUND,
    boxShadow: 'none',
    border: `1px solid ${WHITE}`,

    '&:hover': {
      color: SECONDARY_BLUE_2,
      background: SECONDARY_BLUE_BACKGROUND,
      border: `1px solid ${SECONDARY_BLUE_2}`,
      boxShadow: 'none',
    },

    '&:disabled': {
      backgroundColor: SECONDARY_BLUE_BACKGROUND,
      color: SECONDARY_BLUE_2_TRANSPARENT_40,
    },
  },
}));
